export default function setControlsEnabled(enabled) {
  return (notify, getSceneState) => {
    const { controls } = getSceneState();

    controls.enabled = enabled;

    notify();
  };
}
